import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    storeTraitInsert,
    storeTraitsDelete,
    storeTraitsGet,
    traitDelete,
    traitInsert,
    traitsGet,
    traitUpdate
} from "./requests";

export const FETCH_TRAITS_SUCCESS = "FETCH_TRAITS_SUCCESS";
export const FETCH_STORE_TRAITS_SUCCESS = "FETCH_STORE_TRAITS_SUCCESS";
export const TRAITS_REQUEST_LOADING = "TRAITS_REQUEST_LOADING";
export const TRAITS_REQUEST_ERRORS = "TRAITS_REQUEST_ERRORS";

const setLoading = (status = true) => ({
    type: TRAITS_REQUEST_LOADING,
    payload: status
});

export const fetchTraitsList = (jobiId) => dispatch => {
    dispatch(setLoading());
    traitsGet(jobiId)
        .then(response => {
            dispatch({
                type: FETCH_TRAITS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};

export const insertTrait = (data, callback = false) => dispatch => {
    dispatch(setLoading());
    traitInsert(data)
        .then(() => {
            toast("Successfully added new Trait", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
            if (callback) {
                callback(true);
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};

export const updateTrait = (id, data, callback = false) => dispatch => {
    dispatch(setLoading());
    traitUpdate(id, data)
        .then(() => {
            dispatch(setLoading(false));
            toast("Trait has been updated", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback(true);
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};

export const deleteTrait = (id, callback = false) => dispatch => {
    traitDelete(id)
        .then(() => {
            toast("Trait has been deleted", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};


export const fetchStoreTraitsList = (storeId, jobId) => dispatch => {
    dispatch(setLoading());
    storeTraitsGet(storeId, jobId)
        .then(response => {
            dispatch({
                type: FETCH_STORE_TRAITS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};

export const deleteStoreTrait = (id, callback) => dispatch => {
    storeTraitsDelete(id)
        .then(() => {
            toast("Trait has been deleted", {
                type: toast.TYPE.SUCCESS,
            });
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};

export const clearStoreTraits = () => dispatch => {
    dispatch({
        type: FETCH_STORE_TRAITS_SUCCESS,
        payload: []
    });
};

export const insertStoreTrait = (data, callback) => dispatch => {
    dispatch(setLoading());
    storeTraitInsert(data)
        .then(() => {
            toast("Successfully added new Trait", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, TRAITS_REQUEST_ERRORS));
        });
};
